import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.checkall');
import { OnInit } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-checkall',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.checkall/view.scss */
/* src/app/component.checkall/view.scss: no such file or directory */`],
})
export class ComponentCheckallComponent implements OnInit {
    // 🔹 현재 선택된 QA
    public selectedQA: any = null;

    // 🔹 평가 점수 (기본 3점)
    public rating: number = 3;

    // 🔹 검수 코멘트
    public comment: string = "";

    constructor(@Inject( Service) public service: Service) {}

    // ==========================
    // 초기 실행
    // ==========================
    public async ngOnInit() {
        await this.service.init();

        // 🔹 초기 더미 데이터 (선택된 QA 미리보기용)
        this.selectedQA = {
            question: "합곡혈의 주치증은?",
            answer:
                "합곡혈은 제1, 2 장골 사이에 위치하며 소통해표, 통경활락, 청열지통의 효능이 있습니다.\n두통, 치통, 감기, 복통에 주로 사용하며 사관혈의 하나입니다.",
        };
    }

    // ==========================
    // 평가 점수 선택
    // ==========================
    public setRating(star: number): void {
        this.rating = star;
        console.log(`⭐ 현재 선택된 점수: ${this.rating}`);
    }

    // ==========================
    // 승인 / 반려 동작
    // ==========================
    public approveQA(): void {
        console.log("✅ 승인 처리됨");
        console.log("평가 점수:", this.rating);
        console.log("검수 코멘트:", this.comment);
    }

    public rejectQA(): void {
        console.log("❌ 반려 처리됨");
        console.log("평가 점수:", this.rating);
        console.log("검수 코멘트:", this.comment);
    }

    // ==========================
    // 외부에서 선택된 QA 갱신 (왼쪽 리스트와 연동용)
    // ==========================
    public updateSelectedQA(qa: any): void {
        this.selectedQA = qa;
        this.comment = "";
        this.rating = 3; // 초기화
        console.log("🟢 새로운 QA 선택됨:", qa);
    }
}

export default ComponentCheckallComponent;